// IrelandCompanyRegistration.jsx
import React from "react";

export default function IrelandCompanyRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Ireland Company Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists with Ireland Company Registration in compliance with CRO requirements.
          </p>
          <p className="text-gray-700">
            Complete LTD incorporation through CORE portal including Form A1 submission, constitution filing, company secretary appointment, registered office validation, and Certificate of Incorporation issuance within 5-10 days.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: Ireland business incorporation and CRO compliance) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/163488/pexels-photo-163488.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Ireland company registration and CRO compliance"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation preparation for seamless CRO approval and incorporation.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Director and shareholder details (Form A1 information and consents)</li>
                <li>Registered office address (Irish physical address proof)</li>
                <li>Identity proof (passport copies and KYC verification)</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Proven expertise in Irish LTD registrations through CORE system with 100% CRO success rate and comprehensive post-incorporation compliance.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Irish Corporate Law Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete Companies Act 2014 knowledge including CORE portal processes, Form A1 requirements, company secretary obligations, EEA director rules, constitution compliance, and CRO regulatory standards.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Documentation
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise Form A1 preparation, constitution drafting, director consents, Section 137 bond coordination (if required), registered office validation, and CORE system submissions ensuring first-time approvals.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Professional Service
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end service from name reservation through Certificate of Incorporation, CRO number issuance, Revenue tax registrations, company secretary appointment, corporate bank introductions, and first-year compliance advisory.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
